// src/utils/validation.js

/**
 * Validates a phone number to ensure it consists of exactly 10 digits.
 * @param {string} phone - The phone number to validate.
 * @returns {string|null} - Returns an error message if invalid, otherwise null.
 */
export function validatePhoneNumber(phone) {
  const trimmedPhone = phone.trim();
  const phoneRegex = /^\d{10}$/;
  if (!phoneRegex.test(trimmedPhone)) {
    return "Please enter a valid 10-digit phone number.";
  }
  return null;
}

/**
 * Validates an OTP to ensure it consists of exactly 6 digits.
 * @param {string} otp - The OTP to validate.
 * @returns {string|null} - Returns an error message if invalid, otherwise null.
 */
export function validateOtp(otp) {
  const trimmedOtp = otp.trim();
  const otpRegex = /^\d{6}$/;
  if (!otpRegex.test(trimmedOtp)) {
    return "Please enter a valid 6-digit OTP.";
  }
  return null;
}

export function validateEmail(email) {
  const trimmedEmail = email.trim();
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(trimmedEmail)) {
    return "Please enter a valid email address.";
  }
  return null;
}

export function validateRequired(value, fieldName) {
  if (!value.trim()) {
    return `${fieldName} is required.`;
  }
  return null;
}

export function validateZipCode(zip) {
  const trimmedZip = zip.trim();
  const zipRegex = /^\d{5,6}(?:[-\s]\d{4})?$/;
  if (!zipRegex.test(trimmedZip)) {
    return "Please enter a valid zip/postal code.";
  }
  return null;
}

/**
 * Validates that a value contains only alphabets and spaces.
 * @param {string} value
 * @param {string} fieldName
 * @returns {string|null}
 */
export function validateAlphabet(value, fieldName) {
  if (!value) {
    return `${fieldName} is required.`;
  }

  // trim and normalize spaces
  const cleanedValue = value.replace(/\s+/g, " ").trim();

  // alphabets + space only
  const alphaRegex = /^[A-Za-z\s-]+$/;

  if (!alphaRegex.test(cleanedValue)) {
    return `${fieldName} should contain only alphabets.`;
  }

  return null;
}
